// Onda E-2 (decisão H3) / Story 70.2 (RC-143) — as chaves de liga/pausa das mensagens automáticas
// e o padrão de cada uma quando a chave está ausente (o comportamento dos envios). Uma definição
// só: a tela Mensagens, a tela Clínica e o progresso do onboarding leem daqui.
export const MESSAGE_DISPATCH_DEFAULTS = Object.freeze({
    confirmation: { flag: 'confirmationEnabled', defaultOn: true },
    reminder_24h: { flag: 'reminder24h', defaultOn: true },
    reminder_1h: { flag: 'reminder1h', defaultOn: false },
    followup: { flag: 'followUpEnabled', defaultOn: false },
    cancellation: { flag: 'cancellationEnabled', defaultOn: true },
    reactivation: { flag: 'reactivationEnabled', defaultOn: false },
    birthday: { flag: 'birthdayEnabled', defaultOn: true },
    nps: { flag: 'npsEnabled', defaultOn: false },
});
export const MESSAGE_DISPATCH_TYPES = Object.keys(MESSAGE_DISPATCH_DEFAULTS);
const KEY_DEFAULT_ON = Object.freeze({
    ...Object.fromEntries(Object.values(MESSAGE_DISPATCH_DEFAULTS).map(({ flag, defaultOn }) => [flag, defaultOn])),
    remindersEnabled: true,
});
/** Valor efetivo de uma chave sozinha: o gravado ou, ausente, o padrão do envio (a pausa geral vale ligada). */
export function isMessageDispatchKeyOn(settings, key) {
    const raw = settings?.[key];
    return KEY_DEFAULT_ON[key] ? raw !== false : raw === true;
}
/** Valor efetivo da mensagem: o da chave; a pausa geral dos lembretes vence os dois lembretes. */
export function isMessageDispatchOn(settings, type) {
    if ((type === 'reminder_24h' || type === 'reminder_1h') && !isMessageDispatchKeyOn(settings, 'remindersEnabled'))
        return false;
    return isMessageDispatchKeyOn(settings, MESSAGE_DISPATCH_DEFAULTS[type].flag);
}
export function anyMessageDispatchOn(settings) {
    return MESSAGE_DISPATCH_TYPES.some((type) => isMessageDispatchOn(settings, type));
}
//# sourceMappingURL=message-dispatch.js.map